import React from 'react'
import { Helmet } from 'react-helmet-async'

/**
 * Names the browser tab "Trustero AI - <title>" (the template is set in
 * MainApp). The most recently mounted one wins, so an open object's title
 * replaces its section's, and unmounting it brings the section's back.
 *
 * defer={false}: Helmet otherwise applies the title in a requestAnimationFrame,
 * which Chrome pauses in background tabs, so a page opened in a new tab would
 * keep the bare "Trustero AI" until it was switched to.
 */
export const DocumentTitle = ({ title }: { title?: string }): JSX.Element => (
  <Helmet title={title} defer={false} />
)
